import { IMessage } from '@/shared/api/types/chat-message';

import { PLAN_STYLES } from '../../consts';

type Props = {
  msg: IMessage;
};

const JiraActionResultMessage = ({ msg }: Props) => {
  const { text, issue_key, link } = msg.payload;

  return (
    <div className="flex justify-end mb-6">
      <div className={`${PLAN_STYLES.plan.container} rounded-lg px-4 py-3 max-w-[420px]}`}>
        <div className={`${PLAN_STYLES.plan.title} font-medium`}>{text}</div>

        {(issue_key || link) && (
          <div className="mt-2 text-sm flex gap-3 items-center">
            {issue_key && (
              <span className="font-mono bg-green-300 px-2 py-0.5 rounded text-black">
                {issue_key}
              </span>
            )}

            {link && (
              <a
                href={link}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:underline"
              >
                Открыть в Jira →
              </a>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default JiraActionResultMessage;
